import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
    const scriptEl = window.document.createElement('script');
    scriptEl.src = '/assets/js/newrelic-v0.js';
    window.document.body.appendChild(scriptEl);
}
//for all environment
try {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = "https://www.google-analytics.com/analytics.js";
    window.document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.innerHTML = `window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
                      ga('create', '${environment.gaKey}', 'auto')`;
    window.document.head.appendChild(script2);
}
catch (ex) {
    console.error('Error appending google analytics');
    console.error(ex);
}
__NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory, { preserveWhitespaces: true })
    .catch(err => console.log(err));
